import { GetOptionAPIReturn } from "@/@types/question-option";
import { getAxiosErrorMessage } from "@/resources";
import api from "@/services/axios";
import { useQuery } from "@tanstack/react-query";

export function usGetByQuestionId(id: string) {
  console.log("=== usGetByQuestionId called ===");
  console.log("questionId:", id);
  console.log("enabled:", !!id);

  const query = useQuery({
    queryKey: ["/options-by-question-id", id],
    queryFn: async () => {
      console.log("🔄 Fetching options for question:", id);
      try {
        const { data } = await api.get<GetOptionAPIReturn>(
          `/questions/options/by-question/${id}`
        );

        console.log("✅ API Response:", data);
        console.log("✅ API Response data:", data.data);
        console.log("✅ API Response data length:", data.data?.length);

        return data;
      } catch (error) {
        console.error("❌ API Error:", error);
        throw new Error(getAxiosErrorMessage(error));
      }
    },
    enabled: !!id, // Só executar se tiver um ID
  });

  console.log("=== Query state ===");
  console.log("isLoading:", query.isLoading);
  console.log("isError:", query.isError);
  console.log("error:", query.error);
  console.log("data:", query.data);

  return query;
}
